import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot, Params, RoutesRecognized, RouterEvent } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class PreviousRouteService {

    private previousUrl: string;
    private previousQueryParams: Params;
    private currentUrl: string;
    private ignore: boolean;

    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
        });
        router.events.pipe(
            filter(e => e instanceof RoutesRecognized),
            pairwise()
            )
            .subscribe((event: any[]) => {
                this.previousUrl = event[0].url;
                this.previousQueryParams = this.router.routerState.snapshot.root.queryParams;
            });
    }

    public getPreviousUrl() {
        if (this.ignore) {
            this.ignore = false;
            return '';
        }
        return this.previousUrl;
    }
    public getPreviousQueryParams() {
        return this.previousQueryParams;
    }
    public setIgnore() {
        this.ignore = true;
    }
}
